import * as React from 'react';
import { inject, observer } from 'mobx-react';
import * as styles from "./Theme.css";
import { ThemeStore } from './stores';
import ThemeService from '../../services/ThemeService';
import { ITheme } from '../../interfaces/ITheme';
import ThemeCardView from './cardView/CardView';
import { IACommandBar } from '../commandBar/CommandBar';
import { IAButton } from '../button/Button';
import ViewPanel from './panels/ViewPanel';
import { IThemePalette } from '../../interfaces/IThemePalette';
import { IAPopup } from '../popup/Popup';
import { LocalizationService } from '../../services/LocalizationService';

export interface IThemeProps {
  themeStore?: ThemeStore;
}

@inject('themeStore')
@observer
export default class Theme extends React.Component<IThemeProps> {
  constructor(props) {
    super(props);
    this.getThemes();
  }

  public componentDidMount(): void {
  }

  private getThemes(): void {
    this.props.themeStore.loading = true;
    // Get tenant themes
    ThemeService.getThemes(this.props.themeStore.environment, this.props.themeStore.token, this.props.themeStore.tenant).then((themes: ITheme[]) => {
      // Set themes
      this.props.themeStore.themes = themes;
      this.props.themeStore.loading = false;
    });
  }

  public render(): JSX.Element {
    return (
      <div className={styles.theme}>
        <div className={styles.section}>
          <div className={styles.pageTitle}>{new LocalizationService().strings.Theme_Title}</div>
          <div className={styles.pageDescription}>{new LocalizationService().strings.Theme_Description}</div>
        </div>
        <div>
          {this.props.themeStore.isDeleteMode == true && this.props.themeStore.themeSelected != undefined &&
            <IAPopup
              headline={new LocalizationService().strings.Messages_DeletePopup_Headline}
              content={
                <div>
                  <div
                    style={{
                      float: "left"
                    }}
                  >
                    {new LocalizationService().strings.Messages_DeletePopup_Message}
                  </div>
                  <div
                    style={{
                      clear: "both",
                      float: "left"
                    }}
                  >
                    <IAButton
                      label={new LocalizationService().strings.Messages_DeletePopup_Yes}
                      buttonColor="#02a5e2"
                      showSpinner={this.props.themeStore.deleting}
                      onClick={() => {
                        this.props.themeStore.deleting = true;
                        ThemeService.deleteTheme(this.props.themeStore.environment, this.props.themeStore.token, this.props.themeStore.tenant, this.props.themeStore.themeSelected.Name).then(() => {
                          this.props.themeStore.deleting = false;
                          this.props.themeStore.isDeleteMode = false;
                          this.props.themeStore.themeSelected = undefined;
                          this.getThemes();
                        });
                      }}
                      style={{
                        marginTop: 20,
                        float: "left"
                      }}
                    />
                    <IAButton
                      label={new LocalizationService().strings.Messages_DeletePopup_No}
                      buttonColor={"#999999"}
                      showSpinner={false}
                      onClick={() => {
                        this.props.themeStore.isDeleteMode = false;
                        this.props.themeStore.themeSelected = undefined;
                      }}
                      style={{
                        marginTop: 20,
                        marginLeft: 10,
                        float: "left"
                      }}
                    />
                  </div>
                </div>
              }
              close={() => {
                this.props.themeStore.isDeleteMode = false;
                this.props.themeStore.themeSelected = undefined;
              }}
            />
          }
        </div>
        <IACommandBar
          showBar={true}
          leftSideContent={
            <div>
              <IAButton
                label={new LocalizationService().strings.Messages_Add}
                buttonColor="transparent"
                textColor="#333333"
                icon="Add"
                iconColor="#02a5e2"
                height={22}
                fontSize={14}
                dataAutomationId="theme-add-new"
                onClick={() => {
                  const newTheme: ITheme = {
                    Name: "",
                    Palette: {
                      themePrimary: "#0078d4",
                      neutralPrimary: "#323130",
                      white: "#ffffff",
                      themeLighterAlt: "#eeeeee"
                    } as IThemePalette
                  }
                  this.props.themeStore.addTheme(newTheme);
                  this.props.themeStore.isAddMode = true;
                }}
              />
            </div>
          }
        />
        <ThemeCardView />
        <ViewPanel
          themeSelected={this.props.themeStore.themeSelected}
        />
      </div>
    );
  }
}